import { useEffect } from "react";
import { PlanningApplication } from "react-migration/domains/planning/types";
import { LayerTypePrintableProps } from "../../../types";
import { InsightsSummaryAccordion } from "../../../Bundle/Workbench/AssessmentTab/InsightsSummaryCard/InsightsSummaryAccordion";
import { KeyStatsSection } from "./KeyStatsSection";
import { RecentApplicationsContainer } from "./RecentApplicationsLayerSummary";
import { useRecentPlanningKeyInsights } from "./useRecentPlanningKeyInsights";
import { useRecentApplicationsBySelection } from "./useRecentApplicationsBySelection";

function RecentApplicationsLayerSummary({
  applications,
  loading,
}: {
  applications: PlanningApplication[];
  loading: boolean;
}) {
  useRecentPlanningKeyInsights(applications, loading);

  if (!applications?.length) {
    return;
  }

  const showKeyStats = applications.length > 1;

  return (
    <RecentApplicationsContainer
      tooltip={<h1 className="text-sm font-medium text-text-base-primary">Most recent relevant applications</h1>}
      keyStatsSlot={showKeyStats && <KeyStatsSection applications={applications} />}
    />
  );
}

export function UKPropertyInformationPrintable({ layer, selection, onLoaded, onUnmount }: LayerTypePrintableProps) {
  const { applications, loading, error } = useRecentApplicationsBySelection(selection);

  useEffect(() => {
    if (!loading) {
      onLoaded();
    }
  }, [onLoaded, loading]);

  useEffect(() => {
    return () => {
      onUnmount();
    };
  }, [onUnmount]);

  if (error) {
    // caught by ErrorBoundary
    throw error;
  }

  return (
    <InsightsSummaryAccordion>
      <InsightsSummaryAccordion.Item
        key={layer.id}
        value={layer.id}
        title={layer.title}
        icon="icon-lt-archive-line"
        loading={loading}
        hideLink={true}
      >
        <RecentApplicationsLayerSummary applications={applications} loading={loading} />
      </InsightsSummaryAccordion.Item>
    </InsightsSummaryAccordion>
  );
}
